import { columnsFilter } from 'helpers/defaultData';
import { UPDATE_SETTING_TABLE } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
    setting_columns: JSON.parse(localStorage.getItem("columns")) || columnsFilter
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_SETTING_TABLE: {
            return {
                ...state,
                setting_columns: action.payload,
            };
        }
        default:
            return state;
    }
};